import styled from "styled-components";
import { Box } from "../../common/Box";

export const HeaderContainer = styled(Box)`
    justify-content: space-between;
    height: 80px;
    background: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.03);
`